import * as React from "react";
import { createRoot } from "react-dom/client";

import "./tailwind.css";

import { AppRouter } from "./app/router";
import { AppProvider } from "./app/provider";
import { initializeSentry } from "./lib/sentry-instrumentation";

const root = document.getElementById("root");
if (!root) throw new Error("No root element found");
initializeSentry();

createRoot(root).render(
  <React.StrictMode>
    <AppProvider>
      <AppRouter />
    </AppProvider>
  </React.StrictMode>
);
